import type { PaletteOptions } from '@mui/material/styles';

import { accents, business, mention, neutral, type ColorMode } from './tokens';

/**
 * Light and dark palettes. The neutrals stay close to achromatic on purpose:
 * the three accents are the product's whole visual argument, and a tinted grey
 * would compete with them.
 */
export function buildPalette(mode: ColorMode): PaletteOptions {
  const accent = accents[mode];

  if (mode === 'light') {
    return {
      mode,
      good: accent.good,
      bad: accent.bad,
      ideal: accent.ideal,
      mention: mention.light,
      business: business.light,
      primary: { main: neutral[900], contrastText: neutral[0] },
      secondary: { main: neutral[600], contrastText: neutral[0] },
      success: { main: accent.good.main },
      error: { main: accent.bad.main },
      warning: { main: accent.ideal.main },
      info: { main: neutral[700] },
      background: { default: neutral[25], paper: neutral[0] },
      text: {
        primary: '#14161A',
        secondary: neutral[600],
        disabled: neutral[400],
      },
      divider: neutral[200],
      action: {
        hover: 'rgba(16, 18, 22, 0.04)',
        selected: 'rgba(16, 18, 22, 0.07)',
        disabledBackground: neutral[100],
        focus: 'rgba(16, 18, 22, 0.10)',
      },
    };
  }

  return {
    mode,
    good: accent.good,
    bad: accent.bad,
    ideal: accent.ideal,
    mention: mention.dark,
    business: business.dark,
    primary: { main: neutral[50], contrastText: neutral[950] },
    secondary: { main: neutral[300], contrastText: neutral[950] },
    success: { main: accent.good.main },
    error: { main: accent.bad.main },
    warning: { main: accent.ideal.main },
    info: { main: neutral[300] },
    background: { default: neutral[950], paper: neutral[900] },
    text: {
      primary: '#F2F3F5',
      secondary: '#9BA1AD',
      disabled: '#61666F',
    },
    divider: 'rgba(255, 255, 255, 0.10)',
    action: {
      hover: 'rgba(255, 255, 255, 0.06)',
      selected: 'rgba(255, 255, 255, 0.10)',
      disabledBackground: 'rgba(255, 255, 255, 0.08)',
      focus: 'rgba(255, 255, 255, 0.14)',
    },
  };
}
